<template>
  <v-dialog
    v-bind='$attrs'
    v-on="$listeners"
    transition="dialog-bottom-transition"
    origin="center bottom"
    :hide-overlay="true"
    :persistent="true"
    :value="isOpen && show"
    :no-click-animation="true"
  >
    <template v-slot:default>
      <div class='root-container'>
        <v-container class="fill-height py-0">
          <v-card flat class='d-flex flex-column fill-height card'> 
            <slot>
              <div class="word-or-sentence-displayed" v-html="text"></div>
            </slot>
          </v-card>
        </v-container>
      </div>
    </template>
  </v-dialog>
</template>

<script>
import { defineComponent, onMounted, onBeforeUnmount, ref, computed, watch } from 'vue'
import { debounce } from '../../utils/events';
export default defineComponent({
  props: {
    value: {
      type: Boolean    
    },
    text: {
      type: String
    },
    closeDelayFactor: {
      type: Number,
      default: 50 
    }
  },
  setup(props){
    const isOpen = ref(false);
    const timeout = ref(null);
    const orientation = ref(window.innerHeight <= window.innerWidth ? "landscape" : "portrait");

    const detectOrientation = (event)=>{
      const { angle } = event.target.screen.orientation; // orientation angle
      orientation.value = angle === 90 || angle === -90 ? "landscape" : "portrait";
    }

    onMounted(()=>{
      window.addEventListener("orientationchange", detectOrientation);
    })

    onBeforeUnmount(()=>{
      window.removeEventListener("orientationchange", detectOrientation);
    })

    const show = computed(()=>{
      return orientation.value == "landscape" 
    })
    const closeDelay = computed(()=>{
      return props.closeDelayFactor * (props.text && props.text.length || 0) 
    })
    
    watch(()=>props.value, (newVal)=>{
      const debouncedSwitcher = debounce(()=>{
        isOpen.value = newVal;
      }, newVal ? 0 : closeDelay.value);
      debouncedSwitcher();
    })

    return {
      show,
      closeDelay,
      isOpen
    }
  }
})
</script>

<style lang="scss" scoped>
.v-dialog__content {
  align-items: flex-end;
}
.v-dialog__content ::v-deep .v-dialog{
  margin: 0;
}
.card {
  width: 100%;
  overflow: hidden;
  font-size: 6vh;
}
.mobile .word-or-sentence-displayed {
  font-size: 1.7rem;
  font-size: 8vh;
}
.word-or-sentence-displayed {
  display: flex;
  justify-content: center;
  text-align: center;
  word-spacing: 0.35em;
}
.root-container {
  width: 100%;
  height: 100%;
  padding: 1rem;
}
</style>
